import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import api from "../../config/axiosConfig";
import { HOTEL_URL } from "../../settings/APISetting";
import { sortByProp } from "../../settings/themeSettings";

export const fetchHotels = createAsyncThunk('fetch-hotels', async (page = 1) => {
    const response = await api.get(HOTEL_URL);
    return response.data;
});

export const createHotel = (hotel, err, cb) => {
    api.post(HOTEL_URL, hotel)
        .then((response) => {
            if (cb) cb(response.data);
        })
        .catch((error) => {
            if (err) err(error);
        });
}

export const updateHotel = (hotel, err, cb) => {
    api.put(`${HOTEL_URL}/${hotel.id}`, hotel)
        .then((response) => {
            if (cb) cb(response.data);
        })
        .catch((error) => {
            if (err) err(error);
        });
}

export const deleteHotel = (id, err, cb) => {
    api.delete(`${HOTEL_URL}/${id}`)
        .then((response) => {
            if (cb) cb(response);
        })
        .catch((error) => {
            if (err) err(error);
        });
}

const hotelSlice = createSlice({

    name: 'hotels',
    initialState: { hotels: [], hotelsFetchStatus: '' },

    reducers: {
        addHotel: (state, action) => {
            state.hotels = [...state.hotels, action.payload].sort((a,b) => sortByProp(a,b,'nom'));
        }
    },
    extraReducers: (builder) => {
        builder.addCase(fetchHotels.fulfilled, (state, action) => {
            if (Array.isArray(action.payload)) {
                state.hotels = [...action.payload].sort((a, b) => sortByProp(a, b, 'nom'));
                state.hotelsFetchStatus = 'success';
            } else {
                console.error("fetchHotels payload is not an array:", action.payload);
                state.hotels = [];
                state.hotelsFetchStatus = 'error';
            }
        }).addCase(fetchHotels.pending, (state, action) => {
            state.hotelsFetchStatus = 'loading';

        }).addCase(fetchHotels.rejected, (state, action) => {

            state.hotelsFetchStatus = 'error';

        });
    }


});
export const { addHotel } = hotelSlice.actions;
export default hotelSlice;